/**
 * Contact Page API service
 */

import { fetchStrapi } from './strapi';

export interface ContactPage {
  heading: string;
  subheading: string;
  contactInfoHeading: string;
  phone: string;
  email: string;
  address: string;
  formHeading: string;
  mapEmbedUrl: string;
  successMessage: string;
  errorMessage: string;
}

/**
 * Fetch contact page data from Strapi
 */
export async function fetchContactPage(): Promise<ContactPage | null> {
  try {
    const response = await fetchStrapi<any>('/kontakt-seite');

    if (!response.data) {
      return null;
    }

    const data = response.data;

    return {
      heading: data.ueberschrift || '',
      subheading: data.unterueberschrift || '',
      contactInfoHeading: data.kontaktInfoUeberschrift || '',
      phone: data.telefon || '',
      email: data.email || '',
      address: data.adresse || '',
      formHeading: data.formularUeberschrift || '',
      mapEmbedUrl: data.kartenEinbettungsUrl || '',
      successMessage: data.erfolgsNachricht || '',
      errorMessage: data.fehlerNachricht || '',
    };
  } catch (error) {
    console.error('Error fetching contact page from Strapi:', error);
    return null;
  }
}
